export default "/images/a6080a4091d0457f011f5eca516c43ae.avif";